import moment from "moment";
import * as configUtils from "util/config";

export const echeckTitles = ["echecks.consult.title", "echecks.operating.title"];
export const echeckTabTitles = ["received.echeqs.title", "emitted.echeqs.title"];
export const echeqOptions = ["received.echeqs", "emitted.echeqs"];

export const receivedEcheqsStatusActions = {
    "EMITIDO-PENDIENTE": ["ADMIT", "REPUDIATE"],
};

export const emittedEcheqsStatusActions = {
    "EMITIDO-PENDIENTE": ["ANULATE-ECHEQ"],
};

export const characters = configUtils.getArray("echecks.characters", ["A la orden", "No a la orden"]);

export const emisionModes = configUtils.getArray("echecks.modes", ["INDI", "MULT", "PERS"]);

export const endorseType = configUtils.getArray("echecks.endorse.types", ["NOM", "NEG"]);

export function findEmisor(echeq, environmentCuit) {
    let emisor = {
        emisorRazonSocial: echeq.emisor_razon_social,
        emisorDocumento: "CUIT ".concat(" ", echeq.emisor_cuit),
    };

    if (echeq.total_endosos > 0 && echeq.cheque_caracter === "A la orden") {
        const miEndoso = echeq.endosos.find(
            (endoso) => endoso.benef_documento === environmentCuit && endoso.emisor_documento !== environmentCuit,
        );

        if (miEndoso?.emisor_documento) {
            emisor = {
                emisorDocumento: miEndoso.emisor_documento_tipo.concat(" ", miEndoso.emisor_documento),
                emisorRazonSocial: miEndoso.emisor_razon_social,
            };
        }
    }
    if (echeq.total_cesiones > 0 && echeq.cheque_caracter.toLowerCase() === "no a la orden") {
        const miCesion = echeq.cesiones.find(
            (cesion) => cesion.cesionario_documento === environmentCuit && cesion.cedente_documento !== environmentCuit,
        );

        if (miCesion?.cedente_documento) {
            emisor = {
                emisorDocumento: miCesion.cedente_documento_tipo.concat(" ", miCesion.cedente_documento),
                emisorRazonSocial: miCesion.cedente_nombre,
            };
        }
    }
    return emisor;
}

export const states = configUtils.getArray("echecks.states", [
    "TODOS",
    "ACTIVO",
    "ACTIVO-PENDIENTE",
    "ANULADO",
    "AVAL-PENDIENTE",
    "CADUCADO",
    "CESION-PENDIENTE",
    "CUSTODIA",
    "DEPOSITADO",
    "DEVOLUCION-PENDIENTE",
    "EMITIDO-PENDIENTE",
    // "NEGOCIACION",
    // "NEGOCIACION-PENDIENTE",
    "PAGADO",
    "PRESENTADO",
    "RECHAZADO",
    "REPUDIADO",
]);

export const multipleEcheckActions = configUtils.getArray("echecks.multiple.actions", [
    "ADMIT",
    "CUSTODY",
    "DEPOSIT",
    "EMIT-CESION",
    "ENDORSE",
    // "NEGOTIATE",
    "REPUDIATE",
    "ANULATE-CESION",
    "ANULATE-ENDORSE",
]);

export const ownerships = configUtils.getArray("echecks.ownerships", ["TODOS", "TITULAR", "NO TITULAR"]);

export const checkDisableMultiple = (echeq, environmentCuit, status) => {
    const isExpired = moment(echeq.fecha_pago)
        .add("days", 1)
        .isSameOrBefore(moment());

    if (isExpired) {
        return true;
    }

    if (
        status === "ACTIVO-PENDIENTE" ||
        status === "EMITIDO-PENDIENTE" ||
        status === "CESION-PENDIENTE" ||
        status === "ACTIVO" ||
        echeq.estado === "RECHAZADO" ||
        status === "TODOS"
    ) {
        if (echeq.estado === "EMITIDO-PENDIENTE") {
            return false;
        }
        if (echeq.estado === "ACTIVO") {
            if (echeq.tenencia_beneficiario_documento === environmentCuit) {
                return false;
            }
            return true;
        }

        if (echeq.estado === "ACTIVO-PENDIENTE") {
            if (
                echeq.total_endosos === 0 ||
                (echeq.total_endosos > 0 && echeq.endosos[0].emisor_documento !== environmentCuit)
            ) {
                return true;
            }
            return false;
        }

        if (echeq.estado === "CESION-PENDIENTE") {
            if (echeq.total_cesiones > 0 && echeq.cesiones[0].cedente_documento === environmentCuit) {
                return false;
            }
            return true;
        }

        if (echeq.estado === "RECHAZADO") {
            return true;
        }
    }

    return true;
};

export const createEmisionEcheqList = (form) => {
    let echeqList = [];
    const { amountField, reference, referencevalue, date, type, quantity } = form;

    for (let i = 0; i < form.quantity; i++) {
        echeqList = [
            ...echeqList,
            { amount: parseFloat((amountField.amount / quantity).toFixed(2)), reference, referencevalue, date, type },
        ];
    }

    return echeqList;
};

export function findBeneficiary(echeq, environmentCuit) {
    let beneficiario = {
        beneficiarioRazonSocial: echeq.beneficiario_nombre,
        beneficiarioDocumento: echeq.beneficiario_documento_tipo
            .toUpperCase()
            .concat(" ", echeq.beneficiario_documento),
    };

    if (echeq.total_endosos > 0 && echeq.cheque_caracter === "A la orden") {
        const miEndoso = echeq.endosos.find((endoso) => endoso.emisor_documento === environmentCuit);

        if (miEndoso?.emisor_documento) {
            beneficiario = {
                beneficiarioDocumento: miEndoso.benef_documento_tipo.concat(" ", miEndoso.benef_documento),
                beneficiarioRazonSocial: miEndoso.benef_razon_social,
            };
        }
    }
    if (echeq.total_cesiones > 0 && echeq.cheque_caracter.toLowerCase() === "no a la orden") {
        const miCesion = echeq.cesiones.find((cesion) => cesion.cedente_documento === environmentCuit);

        if (miCesion?.cedente_documento) {
            beneficiario = {
                beneficiarioDocumento: miCesion.cesionario_documento_tipo.concat(" ", miCesion.cesionario_documento),
                beneficiarioRazonSocial: miCesion.cesionario_nombre,
            };
        }
    }
    return beneficiario;
}

export const multipleEcheqsTicketData = (echeqAction) => {
    // TODO BIBANK CHANGE I18N MSJ IN NEGOTIATE
    const body = {
        negotiate: [
            { accountLabel: "multiple.echeq.account" },
            { type: "multiple.echeq.type" },
            { reference: "multiple.echeq.reference" },
            { referencevalue: "multiple.echeq.reference.value" },
        ],
        endorse: [
            { type: "echecks.endorse.type.label" },
            { reference: "echecks.echeckReference" },
            { referencevalue: "echecks.echeckReferenceValue" },
        ],
        cesion: [
            { address: "echecks.address" },
            { reference: "echecks.echeckReference" },
            { referencevalue: "echecks.echeckReferenceValue" },
        ],
    };

    return body[echeqAction];
};

export const statusTagColor = (state) => {
    switch (state) {
        case "EMITIDO-PENDIENTE":
            return "warning";
        case "ACTIVO":
            return "success";
        case "CUSTODIA":
            return "success";
        case "PRESENTADO":
            return "success";
        case "ACTIVO-PENDIENTE":
            return "warning";
        case "DEVOLUCION-PENDIENTE":
            return "warning";
        case "REPUDIADO":
        case "RECHAZADO":
            return "error";
        case "ANULADO":
            return "error";
        case "DEPOSITADO":
            return "success";
        case "PAGADO":
            return "error";
        case "CADUCADO":
            return "error";
        case "NEGOCIACION":
            return "success";
        case "NEGOCIACION-PENDIENTE":
            return "warning";
        case "CESION-PENDIENTE":
            return "warning";
        default:
            return "success";
    }
};
